/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React, {useEffect, useState} from 'react'
import { useHistory, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import {
    Color,
    Modal,
    Label,
    Column,
    ModalTitle,
    TitleSection,
    ContentSection,
    Row,
    Button,
} from "trux"
import { useVideoControls } from "trux/dist/organisms/VideoPlayer"
import './NoFullGameDialog.css'

export const NoFullGameDialog = () => {
    const history = useHistory()
    const location = useLocation()
    const event = useSelector((state) => state.video.value.source)
    const [fullGameTime, setFullGameTime] = useState(0)
    let createLink = history.location.pathname.replace("/save/profile", "/create-moment") + `/start=${fullGameTime}`
    const { play, pause } = useVideoControls()

    const onClose = () => {
        let newPath = location.pathname.replace(/^#\//gi, '/').replace(/\/save\/profile.*$/, '')
        return history.push(newPath)
    }

    useEffect(() => {
        if (event?.meta?.type === "FullGameVideo") {
            let gameTime = event.full_game_time
            let video = document.querySelector(`.VideoPlayer video.main-video[data-active=\"true\"]`)
            if (video) {
                gameTime += video.currentTime
            }
            gameTime = Math.round(gameTime)
            setFullGameTime(gameTime)
        }
    }, [event])

    useEffect(() => {
        pause()
        return () => {
            play()
        }
    }, [pause, play])

    return (
        <Modal trkContext="No Full Game Modal" open={true} onShadeClick={() => onClose()} className="no-full-game-modal">
            <TitleSection onCloseClick={() => onClose()} >
                <ModalTitle content="Saving to Trace iD" />
            </TitleSection>
            <ContentSection>
                <Label
                    center
                    type={Label.Type.Body}
                    color={Color.Grey1}
                    content={`Recruiters and family like to consume short, digestible clips. That's why only moments and touch chains can be added to your iD.`}
                />
                <Row
                    justifyContent="center"
                    marginTop="8"
                    marginBottom="8"
                >
                    <Button
                        primary
                        content="Create a Moment"
                        trkAction="Create a Moment"
                        onClick={() => history.push(createLink)}
                    />
                </Row>
                <Column justifyContent="center" center spacingBottom="4">
                    <Label
                        center
                        bold
                        type={Label.Type.Body}
                        color={Color.Black}
                        content={'Looking for more?'}
                    />
                    <a href={window.location.hash.replace('/save/profile', '')+'/choose'}>Select another playlist</a>
                </Column>
            </ContentSection>
        </Modal>
    )
}
